import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteVulnTemplateSelected, hideVulnTemplateModalDelete
} from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import ModalConfirmation from 'Common/Components/ModalConfirmation';
import { selectShowDeleteConfirmation, selectTemplatesSelected } from 'store/KnowledgeBase/selectors';

const DeleteConfirmationModal = () => {
  const dispatch = useDispatch();
  const showDeleteConfirmation = useSelector(selectShowDeleteConfirmation);
  const templatesSelected = useSelector(selectTemplatesSelected);

  return (
    <ModalConfirmation
      show={ showDeleteConfirmation }
      handleSubmit={ () => dispatch(deleteVulnTemplateSelected()) }
      handleClose={ () => dispatch(hideVulnTemplateModalDelete()) }
      entity="template"
      count={ templatesSelected.length }
      wrapperTestId="kb-confirm-dialog"
      confirmButtonTestId="kb-confirm-ok"
      cancelButtonTestId="kb-confirm-cancel"
    />
  );
};

export default DeleteConfirmationModal;
